module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-custom",
    staticStyle: {
      "margin": "auto",
      "text-align": "center",
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "img-wrap"
  }, [_c('div', {
    staticClass: "page-caption"
  }, [_c('h3', {
    staticClass: "caption"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_vm._v("请使用APP来完成实名认证操作，如未安装APP请前往下载页面安装。")])]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/app-qrcode.png",
      "alt": "",
      "width": "160"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "caption"
  }, [_vm._v("（扫码下载APP）")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6435878c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/authentication.vue
// module id = 608
// module chunks = 1